// Style
import style from "./post-card.module.scss";

// Components
import Terms from "../terms/terms";
import BackgroundColor from "@/components/bg-color/bg-color";
import Link from "next/link";

export default function PostCard({ post, displayType, settings }) {
  //   function getCard(displayType) {
  //     if (displayType === "standard") {
  //       return;
  //     } else if (displayType === "list") {
  //       return <li>{post.title}</li>;
  //     }
  //   }

  // Variables
  const featImg = post.featuredImage?.node;

  const contOpt = settings.postContentOptions ?? [];
  const hasAuthor = contOpt.includes("author");
  const hasDate = contOpt.includes("date");
  const hasCat = contOpt.includes("category");
  // const hasTag = contOpt.includes("tag");
  const hasExcerpt = contOpt.includes("excerpt");
  const hasLink = settings.hasLink;

  const author = post.author?.node;
  const date = new Date(post.date);
  const dateOptions = {}; //  {  weekday: "long",  year: "numeric",   month: "long",   day: "numeric",};
  const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  // const cats = post?.categories?.nodes ?? post?.eventTypes?.nodes ?? "";
  const cats = post?.categories?.nodes ?? "";

  // const tags = ;
  let excerpt = post.excerpt;
  let shortenEx = true; // shows "Read More" by default
  if (excerpt && settings.excerptLength) {
    const truncEx = excerpt.replace("[&hellip;]", "").split(" ");
    shortenEx = truncEx.length > settings.excerptLength;

    excerpt = shortenEx
      ? truncEx.splice(0, settings.excerptLength).join(" ") + "..."
      : excerpt;
  }

  const displayStyles = settings.displayStyles?.[displayType + "ItemSettings"];

  const LinkWrapper = ({ hasLink, link, className, children }) =>
    hasLink && link ? <Link href={link}>{children}</Link> : children;

  return (
    <div
      className={style.postCard}
      style={{ padding: displayStyles?.itemPadding ?? "1.5rem 0" }}
    >
      {/* {displayType == "list" && <li>{post.title}</li>} */}
      {/* {getCard(displayType)} */}

      {featImg && <img src={featImg.sourceUrl} />}
      {hasDate && <p>{formattedDate}</p>}
      {hasAuthor && <p>By: {author.name}</p>}

      {hasCat && cats && <Terms terms={cats} />}

      <LinkWrapper hasLink={hasLink} link={post.uri}>
        {displayStyles?.itemBackgroundColor && (
          <BackgroundColor
            colorSettings={displayStyles.itemBackgroundColor?.colorSettings}
          />
        )}
        {post.title ? <h3>{post.title}</h3> : <Skeleton />}
        {hasExcerpt && excerpt && (
          <>
            <div
              className="excerpt"
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
            {shortenEx && (
              <p className={style.cta}>
                {settings.readMoreLabel ?? "Read More"}
              </p>
            )}
          </>
        )}
      </LinkWrapper>
    </div>
  );
}
